import { render, staticRenderFns } from "./CommunicationBox.vue?vue&type=template&id=2d6eb13e&scoped=true&"
import script from "./CommunicationBox.vue?vue&type=script&lang=js&"
export * from "./CommunicationBox.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationBox.vue?vue&type=style&index=0&id=2d6eb13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6eb13e",
  null
  
)

export default component.exports